import React, { useState } from 'react';
import { useRouteError } from "react-router-dom";
import { useLocalStorage } from "../hooks/useLocalStorage";
import useAuth from "../hooks/useAuth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';
import useFetchData from '../hooks/useFetchData';
import { Menu, MenuItem, MenuDashboard } from "../components/Menu";


const Dashboard = (props) => {
    const [user, setUser] = useLocalStorage("user", null);
    const { logout } = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const openMenu = () => {
        setIsOpen(!isOpen)
    }

    const closeMenu = () => {
        setIsOpen(false);
    }
    
    return (
    
        <div className="flex flex-col lg:flex-row min-h-screen h-full">
        {/* Section Image */}
        <div className="w-full lg:w-1/2 lg:h-screen h-[20vh] md:h-[30vh] relative">
            <img
                src={`${process.env.PUBLIC_URL}/dashboard.webp`}
                alt="Logo Meosis"
                className="h-full w-full object-cover"
            />

            <div className="bg-white rounded-3xl shadow-lg hidden md:hidden absolute inset-0 m-auto w-4/5 h-4/5 xl:w-11/12 lg:flex flex-col xl:flex-row items-center justify-around lg:inset-x-0 lg:bottom-10 lg:top-auto lg:h-52 xl:h-32 lg:gap-2">
                <div className="flex items-center py-1 px-3 md:justify-center">
                    <FontAwesomeIcon icon="fa-solid fa-circle-info" className="text-4xl pr-2" />
                    <div>
                        <h3 className="uppercase text-gray-500 text-xs font-semibold leading-4">nous contacter</h3>
                        <h3 className="text-base font-bold leading-4"><a href="tel:0389308630">03 89 30 86 30</a></h3>
                        <p className="text-base leading-4"><a href="mailto:contact@meosis.fr">contact@meosis.fr</a></p>
                    </div>
                </div>
                <div className="bg-custom-green text-white rounded-3xl flex items-center md:mr-2 py-4 px-6 duration-500 hover:bg-colorbutton md:flex justify-center leading-none">
                    <a href={`https://${user.url_bo}`} target="_blank" className="flex items-center"> 
                        <p className="text-2xl pr-3 inline">J</p>
                        Mon tableau de<br /> bord Jerico
                    </a>
                </div>
                <div className="bg-custom-blue text-white rounded-3xl flex items-center md:mr-2 py-4 px-6 duration-500 hover:bg-[#1d2c36] md:flex justify-center leading-none">
                    <a href="https://calendly.com/suiviclientmeosis/rdv" target="_blank" className="flex items-center">
                        <FontAwesomeIcon icon="fa-solid fa-calendar-days" className="text-2xl pr-3" />
                        RDV avec le <br />Suivi Client
                     </a>
                </div>
            </div>
        </div>

        {/* Section Menu */}
        <div className="w-full lg:w-1/2 lg:h-screen flex flex-col justify-between px-4 pb-10">
            <div className="flex justify-end">
                <button
                    className="m-2 z-[1001] "
                    onClick={openMenu}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-menu"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>
                </button>
            </div>
            <Menu isOpen={isOpen} openMenu={openMenu} closeMenu={closeMenu} />
            <div className=''>
                <a href="https://www.meosis.fr/" target='_blank'>
                    <img src={`${process.env.PUBLIC_URL}/LOGO-MEOSIS.png`} alt="Logo Meosis" className="h-6 w-auto" />
                </a>
            </div> 
            <div className="container my-6 lg:my-0">
                <div className="">
                    <h1 className="text-xl sm:text-3xl text-mlime mb-4 uppercase">Bienvenue sur<br /> votre espace client</h1>
                    <h2 className="text-sm font-bold text-custom-color mb-4 lg:mb-0">
                        {user.contact ? user.contact.prenom + ' ' + user.contact.nom : user.user_login}
                    </h2>
                </div>
            </div>
            <div>
                <MenuDashboard />
            </div>

            {/* Uniquement version responsive */}
            <div className="bg-white rounded-3xl lg:hidden flex flex-col items-center my-10 p-10 px-30 shadow-[0_2px_10px_rgba(0,0,0,0.2)]">
                <div className="flex items-center py-1 px-3 justify-center mb-4">
                    <FontAwesomeIcon icon="fa-solid fa-circle-info" className="text-4xl pr-2" />
                    <div>
                        <h3 className="uppercase text-gray-500 text-xs font-semibold leading-4">nous contacter</h3>
                        <h3 className="text-base font-bold leading-4"><a href="tel:0389308630">03 89 30 86 30</a></h3>
                        <p className="text-base leading-4"><a href="mailto:contact@meosis.fr">contact@meosis.fr</a></p>
                    </div>
                </div>
                <div className="bg-custom-green text-white w-full md:w-1/2 rounded-3xl flex items-center mb-4 py-4 px-6 duration-500 hover:bg-colorbutton md:flex justify-center leading-none">
                    <a href={`https://${user.url_bo}`} target="_blank" className="flex items-center"> 
                        <p className="text-2xl pr-3 inline">J</p>
                        Mon tableau de<br /> bord Jerico
                    </a>
                </div>
                <div className="bg-custom-blue text-white w-full md:w-1/2 rounded-3xl flex items-center mb-4 py-4 px-6 duration-500 hover:bg-[#1d2c36] md:flex justify-center leading-none">
                    <a href="https://calendly.com/suiviclientmeosis/rdv" target="_blank" className="flex items-center">
                        <FontAwesomeIcon icon="fa-solid fa-calendar-days" className="text-2xl pr-3" />
                        RDV avec le <br />Suivi Client
                     </a>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Dashboard